export default "__VITE_ASSET__5157b972__"